import type { Recipe, SuggestionCategory, HelpAction, AgentStatus, ChatMessage } from 'agentic_chat/types';
import { AGENT_STATES, type AIRecipe } from './types';

import { getHelpActionsByContext, getSuggestionsByContext } from './data/AIAgentActionsData';

export function mapRecipeToAgenticChat(recipe: AIRecipe): Recipe {
  return {
    id: recipe.id,
    recipeName: recipe.recipe_name,
    description: recipe.description,
    recipeType: recipe.recipe_type,
    prompt: recipe.recipe,
    tags: recipe.tags,
    key: recipe.key
  };
}

export function mapChatMessage(message: any): ChatMessage {
  return {
    content: message.content,
    type: message.type,
    ...(message.options && { options: message.options })
  };
}

export function mapSuggestionCategory(category: any): SuggestionCategory {
  return {
    title: category.title,
    items: category.items.map((item: any) => ({
      id: item.id,
      name: item.name,
      tooltipContent: item.tooltipContent,
      prompt: item.prompt
    }))
  };
}

export function mapAgentState(state: string, chatSessionId?: string): AgentStatus {
  const stateMap: Record<string, AgentStatus['state']> = {
    [AGENT_STATES.UNINITIALIZED]: 'Idle',
    [AGENT_STATES.IDLE]: 'Idle',
    [AGENT_STATES.PLANNING]: 'Planning',
    [AGENT_STATES.PROCESSING]: 'Processing',
    [AGENT_STATES.COMPLETED]: 'Completed',
    [AGENT_STATES.APPLIED]: 'Applied'
  };

  return {
    state: stateMap[state] || 'Idle',
    chatSessionId: chatSessionId || undefined
  };
}

export function getSuggestions(contextType: string): SuggestionCategory[] {
  const suggestions = getSuggestionsByContext(contextType);
  return suggestions.map(mapSuggestionCategory);
}

export function getHelpActions(contextType: string): HelpAction[] {
  return getHelpActionsByContext(contextType);
}
